/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useTranslation } from 'react-i18next';

const TerminosCondiciones = (props) => {
  const { t } = useTranslation('translations');
  return (
    <div className='col-lg-12'>
      <div className='form-group'>
        <label className='control-label checkbox-news'>
          <input onClick={props.actualizarCheckbox} id='terminos-condiciones' data-name='terminos_condiciones' type='checkbox' required />
          {' '}
          {t('checkout.okTerms')}
          {' '}
          <a className='terminos-y-condiciones' href='/general-conditions' target='_blank'>{t('checkout.termsMessage')}</a>
          .
        </label>
      </div>
    </div>
  );
};
export default TerminosCondiciones;
